/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {BetTheSome, Free2Pay, Pay2Free} from './constant'

function getInitFreeNum(
  {
    freeNum,
    officeFreeNum,
    freeAmount,
    freeLine,
    threme,
    accountBalance,
    betOrders,
  },
  {loadTime, pageInfo}
) {
  const betAmountArr = threme.betAmountList.split(',').map((e) => Number(e))
  const betLineArr = threme.betLineList.split(',').map((e) => Number(e))
  if (freeNum || officeFreeNum) {
    const amount = freeAmount
    const line = freeLine

    const betNo = betAmountArr.findIndex((e) => amount === e)
    const lineNo = betLineArr.findIndex((e) => line === e)
    return {
      betNo: Math.max(0, betNo),
      lineNo: Math.max(0, lineNo),
    }
  }
  if (pageInfo.freeNum || pageInfo.officeFreeNum) {
    const lastBet = betOrders.filter((e) => !e.free)[0]
    let betNo = 0
    let lineNo = 8
    if (lastBet) {
      betNo = betAmountArr.findIndex((e) => lastBet.betAmount === e)
      lineNo = betLineArr.findIndex((e) => lastBet.betLine === e)
    }
    return {
      betNo: Math.max(0, betNo),
      lineNo: Math.max(0, lineNo),
    }
  }

  if (loadTime) return {}

  let line = Math.floor(accountBalance / betAmountArr[0]) || 0
  line = line >= 8 ? 8 : line
  return {
    betNo: 0,
    lineNo: line,
  }
}

function isFree2Pay(data, {pageInfo, loadTime}) {
  if (!loadTime) return BetTheSome
  const curFreeNum = data.freeNum + data.officeFreeNum
  const prevFreeNum = pageInfo.freeNum + pageInfo.officeFreeNum
  if (prevFreeNum && !curFreeNum) return Free2Pay
  if (curFreeNum && !prevFreeNum) return Pay2Free
  return BetTheSome
}

export const LIMIT = 20
const BET_DATA = {
  betData: {},
  svgaQueue: [],
  bonusList: [],
  awardData: {
    betLineData: [],
    order: {},
  },
}
export const getFruitSlot = createAsyncThunk(
  'getFruitSlot',
  async (arg, store: any) => {
    store.dispatch(fruitSlotActions.updateFruitSlotFetching(true))
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/ft_s',
      {
        ...deviceinfo,
        threme_id: 1001,
        threme_type: 1,
        limit: LIMIT,
        offset: 0,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const getAwardOrders = createAsyncThunk(
  'getAwardOrders',
  async (offset: number, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/ft_s',
      {
        ...deviceinfo,
        threme_id: 1001,
        threme_type: 1,
        limit: LIMIT,
        offset,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const fireFruitSlotBet = createAsyncThunk(
  'fireFruitSlotBet',
  async (arg: any, store: any) => {
    const {free, line, amount} = arg
    const {
      env: {deviceinfo},
      Animal_Sloth,
    } = store.getState()
    const resp = await http.post(
      '/live/ground/ft_s_bet',
      {
        ...deviceinfo,
        sid: Animal_Sloth.sid,
        threme_id: 1001,
        threme_type: 1,
        free,
        line,
        amount,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const refreshData = createAsyncThunk(
  'refreshData',
  async (arg: any, store: any) => {
    const {
      env: {deviceinfo},
    } = store.getState()
    const resp = await http.post(
      '/live/ground/ft_s_quick_query',
      {
        ...deviceinfo,
        threme_id: 1001,
        threme_type: 1,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const getBonusAward = createAsyncThunk(
  'getBonusAward',
  async (arg: {order_id: number; line: number}, store: any) => {
    const {
      env: {deviceinfo},
    } = store.getState()
    const resp = await http.post(
      '/live/ground/ft_s_bonus_award',
      {
        ...deviceinfo,
        threme_id: 1001,
        threme_type: 1,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const recordFruitSlotBonus = createAsyncThunk(
  'recordFruitSlotBonus',
  async (arg: any, store: any) => {
    const {
      env: {deviceinfo},
    } = store.getState()
    const resp = await http.post(
      '/consulapi/live/misc/action_log',
      {
        ...deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)
export const getLuckySlotGainFreePlay = createAsyncThunk(
  'getLuckySlotGainFreePlay',
  async (arg: any, store: any) => {
    const {
      env: {deviceinfo},
    } = store.getState()
    const resp = await http.post(
      '/live/ground/ly_s_gain_free_play',
      {
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

const initialState: any = {}

const initData = {
  sid: 0,
  from: '',
  pageInfo: {
    accountBalance: 0,
    poolBalance: 0,
    betOrders: [],
    threme: {
      elements: [],
      awardLineList: '',
      betAmountList: '',
      betLineList: '',
    },
    lamp: {
      person: [],
      personAmount: [],
      personToday: [],
    },
    bonusOrders: [],
    totalFreeNum: 0,
  },
  awardOrders: {
    list: [],
    isAllLoaded: false,
  },
  betData: {},
  awardData: {
    betLineData: [],
    order: {},
  },
  bonusList: [],
  svgaQueue: [],
  isSpinEnd: true,
  scatterShowed: false,
  isDrawLine: false,
  isShowingSvga: false,
  loadTime: 0,
  betLine: {
    betNo: 0,
    lineNo: 0,
  },
  fruitSlotFetching: false,
  lineLock: true,
  free2pay: BetTheSome, // -1:free2pay, 1:pay2free,
  loadingPage: true,
}

export const fruitSlotSlice = createSlice({
  name: 'Animal_Sloth',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updateFruitSlotFetching: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {updateFruitSlotFetching: action.payload})
    },
    setSpinStatus: (state, action: PayloadAction<boolean>) => {
      const isSpinEnd = action.payload
      const cleanAward = isSpinEnd ? {} : BET_DATA
      Object.assign(state, {
        isSpinEnd,
        ...cleanAward,
      })
    },
    clearBetData: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        ...BET_DATA,
      })
    },
    setScatterShowed: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        scatterShowed: true,
      })
    },
    setDrawLine: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        isDrawLine: action.payload,
      })
    },
    setSvgaFinished: (state, action: PayloadAction<any>) => {
      const [, ...rest] = state.svgaQueue
      Object.assign(state, {
        svgaQueue: rest,
      })
    },
    setBetLine: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        betLine: {
          ...state.betLine,
          ...action.payload,
        },
      })
    },
    setLineLock: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        lineLock: action.payload,
      })
    },
    updateBetData: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        pageInfo: {
          ...state.pageInfo,
          ...action.payload,
        },
      })
    },
    updateSid: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        ...action.payload,
      })
    },
    changeLoadingPage: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        ...action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFruitSlot.fulfilled, (state, action) => {
      const betLine = getInitFreeNum(action.payload, state)
      const free2pay = isFree2Pay(action.payload, state)
      const awardOrders = action.payload.awardOrders || []
      Object.assign(state, {
        pageInfo: {
          ...state.pageInfo,
          ...action.payload,
          totalFreeNum: action.payload.freeNum + action.payload.officeFreeNum,
        },
        awardOrders: {
          list: [...awardOrders],
          isAllLoaded: awardOrders.length < LIMIT,
        },
        loadTime: state.loadTime + 1,
        betLine: {
          ...state.betLine,
          ...betLine,
        },
        fruitSlotFetching: false,
        lineLock: free2pay === BetTheSome ? state.lineLock : false,
        free2pay,
      })
    })
    builder.addCase(getFruitSlot.rejected, (state, action) => {
      Object.assign(state, {
        fruitSlotFetching: false,
      })
    })
    builder.addCase(getAwardOrders.fulfilled, (state, action) => {
      Object.assign(state, {
        awardOrders: {
          list: [...state.awardOrders.list, ...action.payload.awardOrders],
          isAllLoaded: action.payload.awardOrders.length < LIMIT,
        },
      })
    })
    builder.addCase(fireFruitSlotBet.fulfilled, (state, action) => {
      const {megaInfo, winCount, freeCount, bonusMap} = action.payload.awardData
      const svgaQueue = []
      if (winCount > 0) svgaQueue.push({index: 'winCount', winCount, megaInfo})
      if (freeCount > 0) svgaQueue.push({index: 'freeCount', freeCount})
      if (Object.keys(bonusMap).length > 0) {
        svgaQueue.push({index: 'bonus', bonus: true})
      }
      const bonusList = Object.keys(bonusMap).map((e) => ({
        index: Number(e),
        lineBonusList: [...bonusMap[e]],
      }))
      Object.assign(state, {
        awardData: {
          ...state.awardData,
          ...action.payload.awardData,
        },
        svgaQueue,
        bonusList,
        betData: {
          ...state.betData,
          ...action.payload.betData,
        },
        lineLock: false,
      })
    })
    builder.addCase(refreshData.fulfilled, (state, action) => {
      Object.assign(state, {
        pageInfo: {
          ...state.pageInfo,
          poolBalance: action.payload.poolBalance,
          lamp: action.payload.lamp,
        },
      })
    })
  },
})
export default fruitSlotSlice.reducer
export const fruitSlotActions = fruitSlotSlice.actions
